module.exports = __webpack_public_path__ + "media/slider/Subscription-4-b2e71e9b.jpg";